var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-2"},[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v("门店数量")]),_c('v-card-text',[_c('v-chart',{staticStyle:{"height":"300px"},attrs:{"autoresize":"","option":_vm.option}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }